import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload } from './utils'

export const getConfilictOfInterestsSchema = (type = '') => {
  const url = `${API_ROOT}/portal/verify-coi?Type=${type}`
  return doGet(url)
}

export const getDocumentConfilictOfInterests = (filePath = '') => {
  const url = `${API_ROOT}/portal/doc/download/sys-doc?filePath=${filePath}`
  return doDownload(url)
}

export const verifyConfilictOfInterests = (request) => {
  const url = `${API_ROOT}/portal/verify-coi`
  return doPost(url, request)
}
